// Client-side mirror of the backend get_video_status() (pp_backend/main.py).
//
// SYNC WARNING: the video-status rules already exist in THREE backend places
// that must be kept in sync (get_video_status in main.py, the status_filter SQL
// in crud.get_videos, and crud.get_pending_paid_amount). This is a FOURTH copy,
// added so admin row actions can update a row's status icon optimistically
// without a full re-fetch. If you change the status rules, change all four.
//
// Returns the same lowercase strings the backend serializes for VideoStatusEnum:
// 'new' | 'recorded' | 'pending_paid' | 'paid'.
export function deriveStatus(video, narrator = 'Won') {
  const ad = video && video.audio_description;
  if (!ad) return 'new';

  const isPaid = narrator === 'Waan' ? ad.is_paid_waan : ad.is_paid;
  const isReviewed = narrator === 'Waan' ? ad.is_reviewed_waan : ad.is_reviewed;
  const s3Link = narrator === 'Waan' ? ad.s3_link_waan : ad.s3_link;
  const needsMore = narrator === 'Waan' ? ad.needs_more_waan : ad.needs_more;

  if (isPaid) return 'paid';
  if (isReviewed) return 'pending_paid';
  if (s3Link && s3Link !== '' && !needsMore) return 'recorded';
  return 'new';
}
